export default __webpack_public_path__ + "static/media/prev-E1A-Orthographic-view.efbee272.png";